import { useEffect } from "react";
import { useUpdateTaskCommentMutation } from "../../../../../app/services/taskCommentsAPI";
import CKEditorComponent from "../../../../../components/finalForms/ui/inputs/ckEditor/CKEditor";
import Buttons from "../../../../../components/ui/button/Buttons";
import ToastService from "../../../../../services/toastService/ToastService";
import { useState } from "react";
import SwalAlert from "../../../../../services/swalService/SwalService";
import { AppIcons } from "../../../../../data/appIcons";

const EditComments = ({ onSuccessPopup, comment, onClose }) => {
    const [commentsData] = useState(comment);

    const [updateEditTaskComment, {
        isLoading: isupdateTaskCommentLoading,
        isSuccess: isSuccessupdateTaskComment,
        data: updateTaskCommentData,
    },] = useUpdateTaskCommentMutation();

    useEffect(() => {
        if (isSuccessupdateTaskComment && updateTaskCommentData) {
            if (updateTaskCommentData.errorMessage.includes("exists")) {
                ToastService.warning(updateTaskCommentData.errorMessage);
                return;
            } else {
                ToastService.success(updateTaskCommentData.errorMessage);
                onSuccessPopup();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccessupdateTaskComment, updateTaskCommentData]);


    const [description, setDescription] = useState(comment.text || "");
    const { error } = SwalAlert();

    const handleSave = () => {
        const request = {
            taskCommentId: commentsData.id,
            commentText: description,
        };
        if (!request.commentText.trim()) {
            error("Please enter your comment", "Validation Failed!");
        }
        else {
            updateEditTaskComment(request);
        }
    }


    return (
        <div>
            <CKEditorComponent
                onCKEditorChange={(newData) => setDescription(newData)}
                data={commentsData.text}
            />

            <div className="row mt-2">
                <div className="col-12">
                    <div className="form-btn d-flex justify-content-end">
                        <Buttons
                            buttonTypeClassName="dark-btn"
                            onClick={onClose}
                            buttonText="Cancel"
                        />
                        <Buttons
                            buttonTypeClassName="theme-btn ml-4"
                            isLoading={isupdateTaskCommentLoading}
                            onClick={handleSave}
                            buttonText="Update"
                            imagePath={AppIcons.AddIcon}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditComments;